import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';
import CheckBoxThreeStateViewModelType from '@/Components/CheckBoxThreeState/CheckBoxThreeStateViewModel';
import CheckBoxThreeStateType from '@/Components/CheckBoxThreeState/CheckBoxThreeState';

export default class CheckBoxThreeStateControlColumnFactory extends ColumnFactory {

    public static isPlainText = false;
    public static isJQueryElement = true;
    private CheckBoxThreeStateViewModel = ComponentManager.getViewModel<typeof CheckBoxThreeStateViewModelType>('CheckBoxThreeStateViewModel');
    private CheckBoxThreeState = ComponentManager.getControl<typeof CheckBoxThreeStateType>('CheckBoxThreeState');

    constructor(private params: any) {
        super(params);
    }

    public getValue(): JQuery<HTMLElement> {
        let checkBoxThreeStateViewModel: CheckBoxThreeStateViewModelType = this.params.CheckBoxThreeStateViewModel || new this.CheckBoxThreeStateViewModel({
            isChecked: this.raw,
            isEnabled: this.observableOrDefault(this.params.isEnabled, false)
        });

        let checkBoxThreeStateControl = new this.CheckBoxThreeState(checkBoxThreeStateViewModel);

        let $control = checkBoxThreeStateControl.getControl();

        return $control;
    }
}

ComponentManager.setFactory('CheckBoxThreeStateControlColumn', CheckBoxThreeStateControlColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');